// extracted by mini-css-extract-plugin
export default {"parent":"mapWidget_parent__psV1+"};